import React, { Component, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form"
import {FieldHolder} from "@/components/holders/FieldHolder";

import { Editor } from 'react-draft-wysiwyg';
import '@/styles/wysiwyg/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw, convertFromHTML, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import store from "@/redux/store";
import {storeBaseSetting2} from "@/reducers/Settings";

import { pdfjs, Document, Page } from 'react-pdf';
import {previewInvoice} from "@/reducers/Settings";

import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "@/components/accordion/index";


/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
*/
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function Invoice({...props}) {
    const pdfdoc = useRef(null);
    const [htmlContent, setHtmlContent] = useState('');
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: props.data.settings_invoice,
      values: props.data.settings_invoice
    })
const _getInitialHTML =(rawObj) => {
    return convertFromRaw();
  }
  
  const previewInvoiceEvent = (event) => {
      let changedObj = getValues();
      if(changedObj["invoice~footer"] != "") {
        changedObj["invoice~footer"] = JSON.stringify(changedObj["invoice~footer"]);
      }
      store.dispatch( previewInvoice(changedObj) );
      
      return false;
  }


    useEffect(() => {
        let invoice_number = 0;
        if(props.data && props.data.settings_invoice && props.data.settings_invoice["invoice.invoice_number"] && props.data.settings_invoice["invoice.invoice_number"] != "") {
            //invoice_number = props.data.settings_invoice["invoice.invoice_number"];
           }
        if(props.data && props.data.settings_invoice && props.data.settings_invoice["invoice~footer"] && props.data.settings_invoice["invoice~footer"] != "") {
            let footerObj = JSON.parse(props.data.settings_invoice["invoice~footer"]);
            if(footerObj.raw) {
                setValue("invoice~footer", footerObj);
    //            let rawObj = JSON.parse(footerObj.raw);
                setHtmlContent((convertFromRaw( footerObj.raw )));
                setEditorState( EditorState.createWithContent( convertFromRaw( footerObj.raw )) )
            }
        }
        
        const getPos =((dest, pageIndex, pageNumber) => {
            
            
            return false;   
        });
        
        //setEditorState( EditorState.createWithContent(_getInitialHTML()) );
    return () => {

    };
  }, []);

    const pdfSTr = store.getState().InvoiceReducer.doc; 

    const onSubmit: SubmitHandler = (data) => {
    event.preventDefault();
    event.stopPropagation();
//        let settings = data.settings_invoice;
        //data["invoice~footer"] = {raw: htmlContent, html: draftToHtml(htmlContent)};
        store.dispatch( storeBaseSetting2( {data: data, type: "invoice"} ) );

      
    return false;

    }

  const onEditorStateChange: Function = (editorState) => {
      setEditorState(editorState);
//      
//      console.log( editorState.getCurrentContent() );
//      console.log( (convertToRaw(editorState.getCurrentContent()) ));
      //props.getContent = editorState.
      //setHtmlContent(draftToHtml(convertToRaw(editorState.getCurrentContent())));
      setHtmlContent((convertToRaw(editorState.getCurrentContent())));
      
      setValue("invoice~footer", {raw: htmlContent, html: draftToHtml(htmlContent)} );
      
  };
  const handleClick = event => {
      
    };
  const  onDocumentLoadSuccess = ((event) => {
    if(pdfdoc && pdfdoc?.current && pdfdoc?.current !== null && pdfdoc?.current.pages.current && pdfdoc?.current.pages.current.length > 0) {
        
        pdfdoc.current.pages.current[0].addEventListener('click', handleClick);
    }
  });
      
    return (
    <div className="space-y-10 divide-y divide-gray-900/10 mt-8">
      <div className="grid grid-cols-2 gap-x-8 gap-y-8 md:grid-cols-12">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4 px-5" onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                  <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null} />


          </div>
        
        <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="6" smcolspan="6" label="Vaste lengte factuur nr." id={"invoice_prefix_number"} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    data-dashlane-disabled-on-field="true"
                    {...register(`invoice~prefix_amount`)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            <FieldHolder colspan="12" smcolspan="6" label="Factuurnr lengte opvullen met" id={"invoice no"} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    max="1"
                    data-dashlane-disabled-on-field="true"
                    {...register(`invoice~prefix_char`)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            </div>
            <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="12" smcolspan="6" label="Factuur prefix" id={"invoice_prefix"} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    data-dashlane-disabled-on-field="true"
                    {...register(`invoice~prefix`)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

            <FieldHolder colspan="12" smcolspan="6" label="Factuur nummer" id={"invoice no"} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    data-dashlane-disabled-on-field="true"
                    {...register(`invoice~number`)}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
        </div>
        
   <Accordion>
            <AccordionItem>
                <AccordionHeader>
                    <h3 className={`accordion-title`}>Factuur header</h3>
                </AccordionHeader>

                <AccordionBody>
                    <div className="accordion-body">
                        Lorem ipsum dolor sit amet.
                    </div>
                </AccordionBody>
            </AccordionItem>

            <AccordionItem>
                <AccordionHeader>
                    <h3 className={`accordion-title`}>Factuur body</h3>
                </AccordionHeader>

                <AccordionBody>
                    <div className="accordion-body">
                        Lorem ipsum dolor sit amet.
                    </div>
                </AccordionBody>
            </AccordionItem>

            <AccordionItem>
                <AccordionHeader>
                    <h3 className={`accordion-title`}>Factuur footer</h3>
                </AccordionHeader>

                <AccordionBody>
                    <div className="accordion-body">

           <div className="col-span-full">
              <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                Factuur footer tekst
              </label>
              <div className="mt-2">

            <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} name="editor1"  toolbar={{options: ['inline', 'textAlign'],textAlign: { inDropdown: false },
inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
  }
            }}/>        
            </div>
            </div>


                    </div>
                </AccordionBody>
            </AccordionItem>
        </Accordion>        
        



         <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button onClick={(event) => previewInvoiceEvent(event)} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Preview PDF
            </button>
            <Link to="" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>

        
        </form>
      <div className="col-span-8">
      {props?.data?.preview_invoice_data &&
<Document ref={pdfdoc} file={`data:application/pdf;base64,${props?.data?.preview_invoice_data}`}  className="bg-gray-100 border-b p-1 flex items-center justify-center text-sm text-gray-600 gap-2 overflow-scroll h-screen" 
height={400} width={400}  onLoadSuccess={onDocumentLoadSuccess}> 

 <Page
                key="Page1"
                pageNumber={1}
                width={600}
                height={400}
                onMouseDown={() => {console.debug(event)}}
                className="bg-gray-100 border-b p-1 flex items-center justify-center text-sm text-gray-600 gap-2 shadow-md" renderAnnotationLayer={false} renderTextLayer={false}

              />

</Document>
          }
      </div>
      </div>
      
      </div>
        
    )
}